import {NavList} from '@primer/react'
import type {Ref} from 'react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {getEffectiveEntryLineClass} from '../../../helpers/get-effective-entry-line-class'
import {useStackMergeabilityUpdates} from '../../../hooks/use-stack-mergeability-updates'
import {EffectiveEntryStatusLabel} from './EffectiveEntryStatusLabel'
import {EffectiveEntryStatusIcon} from './EffectiveEntryStatusIcon'
import {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'

export function StackEntryNavItem({
  entry,
  entryRef,
  tabSuffix,
  currentPullRequestId,
  onSwitchBranch,
}: {
  entry: StackSectionStackEntry
  entryRef?: Ref<HTMLAnchorElement>
  tabSuffix: string
  currentPullRequestId: string
  onSwitchBranch?: () => void
}) {
  const effectiveEntryStatus = entry.effectiveEntryStatus ?? EffectiveEntryStatus.NotReady

  useStackMergeabilityUpdates({basePageDataUrl: entry.pull.url, currentPullRequestId, channels: entry.channels})

  return (
    <NavList.Item
      ref={entryRef}
      href={`${entry.pull.url}${tabSuffix}`}
      aria-current={entry.position === 'CURRENT'}
      onClick={onSwitchBranch}
      className={getEffectiveEntryLineClass(entry)}
    >
      <NavList.LeadingVisual>
        <EffectiveEntryStatusIcon status={effectiveEntryStatus} />
      </NavList.LeadingVisual>
      <span className={entry.position === 'AFTER' ? 'fgColor-muted' : ''}>{entry.pull.title}</span>
      <NavList.Description variant="block">
        <span className="fgColor-muted">
          #{entry.pull.number} · {entry.pull.headBranch}
        </span>
      </NavList.Description>
      <NavList.TrailingVisual>
        <EffectiveEntryStatusLabel status={effectiveEntryStatus} />
      </NavList.TrailingVisual>
    </NavList.Item>
  )
}
